import React           from 'react';
import { withRouter }  from 'react-router';
import * as Components from '../Components';
import uuidv4          from '../../utils/Uuid';

class _dynamic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      map: this.props.map
    };
  }
  
  obj(parent) {
    var newObj = {
      parent: parent,
      components: [],
      layouts: [],
      options: {
        container: false
      }
    }
    return newObj;
  }
  
  components(parent) {
    let html = [];
    for (var i = 0; i < parent.components.length; i++) {
      var layout  = parent.components[i];
      var classes = '';
      var styles = null;
      if (layout.options) {
        if (classes) {
          classes = layout.options.classes.join(' ');
        }
        
        styles  = layout.options.styles;
      }
      
      html.push(
        <div key={i} className={classes} style={styles}>
          {layout.component}
        </div>
      );
    }
    
    return html;
  }
  
  html(parent) {
    let html = [];    
    for (var i = 0; i < parent.layouts.length; i++) {
      var layout = parent.layouts[i];
      if (layout.components.length > 0 && layout.layouts.length > 0) {
        html.push(
          <div key={i} className={layout.options.container ? 'container' : ''}>
              <div className='row'>
              {this.components(layout)}
              {this.html(layout)}
            </div>
          </div>
        );
      }
      else if (layout.components.length > 0 && layout.layouts.length === 0) {
        html.push(
          <div key={i} className={layout.options.container ? 'container' : ''}>
              <div className='row'>
              {this.components(layout)}
            </div>
          </div>
        );
      }
      else if (layout.components.length === 0 && layout.layouts.length > 0) {
        html.push(
          <div key={i} className={layout.options.container ? 'container' : ''}>
              <div className='row'>
              {this.html(layout)}
            </div>
          </div>
        );
      }
    }
            
    return html;
  }
  
  map(map, parent, that) {
    for (var i = 0; i < map.length; i++) {
      var element = map[i];  
      for (var j = 0 ; j < element.components.length; j++) {
        var e = element.components[j];
        if (e.type === 'component') {
          const Component = Components[e.value];
          var newComponent = {
            component: <Component key={uuidv4()} />,
            options: e.options
          };
          parent.components.push(newComponent);      
        }
        else if (e.type === 'layout') {
          var newObj = this.obj(parent);
          newObj.options.container = e.container;
          parent.layouts.push(newObj);
          that.map(e.value, newObj, that);
        }    
      } 
    }
  }

  render() {
    const top = this.obj(null);
    this.map(this.state.map, top, this);
    let html  = this.html(top);
    
    return (
      <div>
        {html}
      </div>
    );
  }
}

export default withRouter(_dynamic);
